import localforage from 'localforage'

/** 业务和系统相关 */
export enum DebitCardStorageKeys {
  Token = 'exchange_h5_debit_token',
  AppUUID = '__app-uuid__',
  LanguageType = 'h5-language-type',
  LanguageKey = 'h5-language',
  LanguageVersion = 'h5_LangWebVersion',
  VendorList = '__vendorList__',
  MyCardStats = '__myCardStats__',
  MyCardList = '__myCardList__',
  ActiveVendorCard = '__activeVendorCard__',
  CurrentUserBill = '__currentUserBill__',
  ActiveMyCard = '__activeMyCard__',
  Config = '__config__',
  ApplyCvCId = '__applyCvcId__',
  CurrentUserCardId = '__currentUserCardId__',
}

export enum StorageIndexDBEnum {
  Language = 'exchange-language',
  StaticTable = 'exchange-static-table',
  CacheLangKeys = 'exchange-cache-lang-keys',
  Config = 'exchange-config',
  StaticTableData = 'exchange-static-table-data',
  CacheKeys = 'exchange-cache-keys',
  MarketQuote = 'exchange-market-quote',
  ContractQuote = 'exchange-contract-quote',
  StaticTableVersionInfo = 'exchange-static-table-version-info',
  ExchangeInfo = 'exchange-exchange-info',
  AgreeNotice = 'agree-notice',
  ThemeType = 'theme-type',
  InviteCode = 'invite-code',
  Scenes = 'scenes',
  ProductId = 'product_id',
  UserDoubleContractUnitType = 'user-double-contract-unit-type',
  ExchangeOpenContractFeature = 'exchange-open-contract-feature',
}

class StorageDB {
  static options: {
    name: string
    storeName: string
    description: string
  } = {
    name: import.meta.env.VITE_PLATFORM || 'crypto-otc',
    storeName: 'exchange-cache-store',
    description: '一些语言包或者静态表数据的缓存',
  }
  constructor() {
    localforage.config(StorageDB.options)
  }

  static initOptions(options: { name: string; storeName: string; description: string }) {
    StorageDB.options.name = options.name
    StorageDB.options.storeName = options.storeName
    StorageDB.options.description = options.description
  }

  get<T>(key: string) {
    return localforage.getItem<T>(key)
  }

  set(key: string, value: any) {
    return localforage.setItem(key, value)
  }

  remove(key: string) {
    return localforage.removeItem(key)
  }

  clear() {
    return localforage.clear()
  }

  async cacheFetch<T>(
    key: string,
    options: {
      fetch: (...args: any[]) => Promise<FetchResponse<T>>
      callback?: (res: T) => void
    },
  ) {
    const cache = await this.get<T>(key)
    if (options.callback && cache) {
      options.callback(cache)
    }

    options.fetch().then((res) => {
      this.set(key, res.data)
      options.callback?.(res.data)
    })
  }
}

export const storageDB = new StorageDB()
